import {
  compose,
  branch,
  renderComponent
} from 'recompose'
import { connect } from 'react-redux'

import { Error } from '../uiLib'
import withInitialData from './withInitialData'

function mapStateToProps(state) {
  return {
    isAuthenticated: state.user.isAuthenticated
  }
}

const AccessDenied = compose(
  withInitialData
)(({ t }) => (<Error message={t('access-denied')} />))

export const isAuthenticatedHOC = (isAuthorized, FailComponent = AccessDenied) => compose(
  connect(mapStateToProps),
  branch(
    props => !props.isAuthenticated,
    props => renderComponent(FailComponent)(props)
  )
)

export default isAuthenticatedHOC



// WEBPACK FOOTER //
// ./components/hoc/isAuthenticated.js